import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlassian/ufo';

import type { NavigationExperienceMap } from './types';

// register the new experience key in http://go/perfportal

export const NavigationExperienceId = {
	goalCreate: {
		experienceId: 'uc-goal-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	teamCreate: {
		experienceId: 'uc-team-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	projectCreate: {
		experienceId: 'uc-project-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	universalCreateComponentLoad: {
		experienceId: 'uc-component-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		},
		instanceId: undefined,
	},
	universalCreatePrefetch: {
		experienceId: 'uc-backend-prefetch',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		},
		instanceId: undefined,
	},
	globalSideNavigationLoad: {
		experienceId: 'global-side-navigation-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		},
		instanceId: undefined,
	},
	customizationModalLoad: {
		experienceId: 'customization-modal-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	customizationModalUpdate: {
		experienceId: 'customization-modal-update',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	globalMoreMenuLoad: {
		experienceId: 'global-more-menu-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
} as const satisfies NavigationExperienceMap;


